
  import {Component, Vue, Watch} from "vue-property-decorator";
  import AppMenu from "@/components/AppMenu.vue";
  import AppDialogContainer from "@/modules/Popup/components/AppDialogContainer.vue";
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import MobileNavigation from "@/components/MobileNavigation.vue";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {antiTheftCars} from "@/modules/CarList/mixins/antitheft.class";
  import {ThemeColorDetect} from "@/plugins/theme-color-detect";
  import AppInstallation from "@/components/AppInstallation.vue";
  import moment from "moment";
  import {ICookieBanner} from "@/shared/CookieBanner/interfaces/cookie-banner.interface";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppDialogContainer,
      AppInstallation,
      AppMenu,
      MobileNavigation,
    },
  })
  export default class App extends Vue {
    resizeTimer = null;

    get storeState(): IAppState { return this.$store.state; }
    get isLoadingApp() { return this.storeState.isLoadingApp; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get isUser() { return this.storeState.auth.isUser; }

    get displayMenu() {
      let display = true;
      let pagesForHide = [
        ROUTE_NAME.PAGE_AUTHORIZATION.toString(),
        ROUTE_NAME.PAGE_REGISTRATION.toString(),
      ];
      display = !pagesForHide.includes(this.$route.name);
      return display;
    }

    async mounted() {
      this.setCssVars();
      window.addEventListener('resize', this.handleResize);

      KeyboardMobileHidden();

      localStorage.setItem(IApp.LocalStorageKeys.LastAppUpdateDate, moment().toDate().toString());
      await this.checkDisplayCookieBanner();
      ThemeColorDetect();
    }

    async checkDisplayCookieBanner() {
      cookieBannerHelper.checkScriptsAccess();
      let displayCookieBanner = true;
      let storageInfo = localStorage.getItem(ICookieBanner.LocalStorageKeys.CookieBanner);
      if (storageInfo) {
        let parsedStorageInfo: ICookieBanner.IStorageInfo = JSON.parse(storageInfo);
        displayCookieBanner = parsedStorageInfo.action === ICookieBanner.ConfirmAction.Ignore;
      }
      if (displayCookieBanner && this.isUser) {
        await this.$store.dispatch('dialog/openDialog', {blockName: 'allPages', dialogName: 'cookieBannerPopup'});
      }
    }

    setCssVars() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        this.setCssVars();
      }, 150);
    }

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
    }

    @Watch('userAccess')
    onUserAccessChange() {
      if (this.userAccess.token) {
        antiTheftCars.init(this);
      }
    }

    @Watch('isUser')
    async onLoginChange() {
      if (this.isUser) {
        await this.checkDisplayCookieBanner();
      }
    }
  }
